// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"02ff0cbe","180":"164a44ab","213":"5e670600","425":"4f692598","439":"b5c75ef0","453":"74c9e65d","606":"334b417d","619":"b2ddf919","621":"2892ab58","769":"a9219704","784":"48f12940","789":"262e05bd","866":"f5a3a817"}[chunkId] + ".chunk.js";
};